import { type GQLWishlistItemFragment } from "@src/graphql.generated";
import { type SPFAvailabilityStatus } from "@src/utils/events";

export interface WishlistEntryModel extends GQLWishlistItemFragment {
    clientArticleInfo?: {
        availability: SPFAvailabilityStatus;
        currency?: string;
        price?: number;
    };
}

export const getWishlistEntry = (sparePartId: string, modelId: string) => `${sparePartId},${modelId}`;

export const resolveWishlistEntry = (entry: string) => {
    const [sparePartId, modelId] = entry.split(",");

    return { sparePartId, modelId };
};
